import { useState } from 'react';
export var usePhoneInput = function (_a) {
    var maskContactInfo = _a.maskContactInfo, onClientInfoUpdated = _a.onClientInfoUpdated, form = _a.form;
    var _b = useState(maskContactInfo), usePhoneFormatter = _b[0], setUsePhoneFormatter = _b[1];
    var onChange = function (phone) {
        if (usePhoneFormatter) {
            setUsePhoneFormatter(false);
        }
        onClientInfoUpdated('phone', phone);
    };
    var setPhoneFromSelectedClient = function (clientPhone) {
        if (clientPhone) {
            form.setValue('phone', clientPhone);
            setUsePhoneFormatter(maskContactInfo);
        }
        else {
            form.setValue('phone', '');
            setUsePhoneFormatter(false);
        }
    };
    return {
        usePhoneFormatter: usePhoneFormatter,
        onChange: onChange,
        setPhoneFromSelectedClient: setPhoneFromSelectedClient,
    };
};
